import axios from 'axios';
import Qs from 'qs';
import { QW_APPLIANCE_HISTORY_URL } from '../config';
import { getAccessToken } from '../util/helper';

const qwApplianceHistory = axios.create({
  baseURL: QW_APPLIANCE_HISTORY_URL,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getAccessToken()}`,
  },
  paramsSerializer(params) {
    return Qs.stringify(params, { arrayFormat: 'brackets' });
  },
});

export default qwApplianceHistory;
